// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1yeVd","label":"Labeled_label__1xkxK","divider":"Labeled_divider__2_rAv"};